// extracted by mini-css-extract-plugin
module.exports = {"fixed-gradient-container":"fixed_gradient__fixed-gradient-container___1Pgdo"};